import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
/*
 * Localized title, subheading, and features heading ("Everything in <lower
 * tier>, plus:") per tier. Keyed on the tier alone (HSOC is a single product
 * line), mirroring the in-app HSOC merch cards.
 *
 * Typed as Record<HsocTierName, HsocTierContent> so the lookup is exhaustive
 * at compile time — adding a tier to HsocTierName forces a new entry here,
 * matching the repo's Record<ProductLevelType, T> convention for per-tier
 * copy. Keys must stay string literals so the i18n static analyzer can see
 * them.
 */
const HSOC_TIER_CONTENT = {
  FREE: {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.free.title"
    }),
    subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.free.subheading"
    }),
    featuresHeading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.free.featuresHeading"
    })
  },
  STARTER: {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.starter.title"
    }),
    subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.starter.subheading"
    }),
    featuresHeading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.starter.featuresHeading"
    })
  },
  PROFESSIONAL: {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.professional.title"
    }),
    subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.professional.subheading"
    }),
    featuresHeading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.professional.featuresHeading"
    })
  },
  ENTERPRISE: {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.enterprise.title"
    }),
    subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.enterprise.subheading"
    }),
    featuresHeading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.merchCard.tiers.enterprise.featuresHeading"
    })
  }
};
export function getHsocTierContent(tierName) {
  return HSOC_TIER_CONTENT[tierName];
}